import * as React from 'react';
import { SVGProps } from 'react';

const IconOpenInNewSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.914 3h4.663L5.5 9.077l1.414 1.414 6.077-6.077v4.663h2V1H6.914v2z" />
    <path d="M5 3v2H3v8h8v-2h2v4H1V3h4z" />
  </svg>
);
export default IconOpenInNewSizeS;
